'use strict';

const defaultConfig = {
	"componentName": "widget",
	"ratingAndReviewContainer": "Rating and Review Container",
	"writeReviewContainer": "Write a Review Container",
	"reviewContainer": "Review Container",
	"previewContainer": "Preview Container",
	"rtlLocales": ['ar-sa', 'en-he', 'ar-ae', 'ar-ma'],

	// carousel config
	"container": "#blueimp-gallery",
	"startSlideshow": false,
	"closeOnEscape": true,
	"enableKeyboardNavigation": true,
	"toggleControlsOnSlideClick":false,
	"toggleControlsOnEnter": false,
	"toggleSlideshowOnSpace": false,
	"hidePageScrollbars": false,
	"continuous": false,
	"fullscreen":false,
	"prevLink": "Prev",
	"nextLink": "Next",
	"firstLink": "First",
	"lastLink": "Last",
	"carousalTiles": {
		"desktop": 7,
		"tablet": 4,
		"mobile": 3
	},

	//form Validation
	"requiredFields": ['rating','reviewTitle', 'reviewComment', 'nickName', 'email', 'termAndConditions', 'firstName', 'lastName'],
	"quesRequiredFields": ['question', 'nickName', 'email', 'termAndConditions', 'firstName', 'lastName'],
	"fieldValidation": {
		rating: {
			value: 0
		},
		title: {
			length: 0,
			value: "",
			max: 255
		},
		comment: {
			min: 10,
			max: 500
		},
		nickName: {
			length: 4,
			value: "",
			max: 80
		},
		email: {
			type: 'email',
			max: 80
		},
		termAndConditions: {
			value: false
		},
		firstName: {
			length: 0,
			value: ""
		},
		lastName: {
			length: 0,
			value: ""
		}
	},
	"fieldValidationMessage": {
		rating: "*Please provide rating",
		title: "*Please provide title",
		titleMax: "(Review title should have max length of 255.)",
		commentMin: "(minimum 10 character required)",
		commentMax: "(maximum 500 characters)",
		captionMax: "90 characters only. (",
		nickName: "Minimum 4 characters required",
		nickNameMax: "(Nick Name should have max length of 80.)",
		email: "*Email is required",
		emailMax: "(Email should have max length of 80.)",
		inCorrectEmail: "*Incorrect email",
		firstName: "*Firstname is required",
		lastName: "*Lastname is required",
		ageConsent: "*Please confirm your age",
		termAndConditions: "*Please accept Terms and Conditions and Privacy Policy",
		uploadImageTypeError: "*Only .png, .jpg, .jpeg .gif is accepted",
		question: "*Please provide question"
	},
	//rating summary fields
	"ratingSummary": {
		"defaultTemplate": ["detail"],
		"ctaText": "Read reviews",
		"labelText": "reviews",
		"noRatingText": "No ratings found for this product"
	},
	//Brand code list where write review button should be disable(not render)
	"writeReviewDisable" : ['']
}

module.exports = defaultConfig;
